import React, { Component } from 'react';
import { connect } from 'react-redux';
import {API_URL} from "../Constants"; // Import API_URL
import ReactGA from 'react-ga';

class MyTable extends Component {

  constructor() {
    super();
    this.state = {
      data: []
    };
    ReactGA.event({
      category: 'TeamStanding',
      action: 'Open'
    });    
  }

  componentDidMount () {
    fetch(`${API_URL}/app/api/v1/games/team-standing`)
              .then(results => {
                return results.json();
              }).then(resp => {
                this.setState({data: resp});
              });
  }

  render() {
    return (
      <div className="card">
    <div className="header">
      <h4 className="title">Team Standing</h4>
    </div>
    <div className="content table-responsive table-full-width">
      <table className="table table-hover table-striped">
        <thead>
          <tr>
          <th>Rank</th>
          <th>Team</th>
            <th>Points</th>
            <th>Score Lead</th>
          </tr>
        </thead>
        <tbody>
          {this.state.data.map(item => (
            <tr key={item.id}>
              <td>{item.rank}</td>
              <td>{item.teamName}</td>
              <td>{item.points}</td>
              <td>{item.scoreLead}</td>
            </tr>
          ))}
        </tbody>
      </table>

    </div>
  </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.Auth.user
});

export default connect(mapStateToProps)(MyTable);


// WEBPACK FOOTER //
// ./src/components/Table/TeamStandingTable.js